"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderExpertRate = exports.renderMoney = exports.renderSegment = exports.renderExperienceGo30 = exports.renderExperience = exports.renderCountry = exports.renderAtheneumOffice = void 0;
var tslib_1 = require("tslib");
var currency_formatter_1 = tslib_1.__importDefault(require("currency-formatter"));
var get_1 = tslib_1.__importDefault(require("lodash/get"));
var time_1 = require("./time");
function renderAtheneumOffice(atheneumOffices, atheneumOfficeId) {
    if (!atheneumOffices)
        return;
    return atheneumOffices[atheneumOfficeId].name;
}
exports.renderAtheneumOffice = renderAtheneumOffice;
function renderCountry(countryNames, countryId) {
    if (!countryNames)
        return;
    return countryNames[countryId];
}
exports.renderCountry = renderCountry;
function renderExperience(experience) {
    if (!experience)
        return '';
    var companyName = (0, get_1.default)(experience, 'company.name', 'Unknown company');
    if (!experience.startDate && !experience.endDate) {
        if (companyName) {
            return companyName;
        }
        return '';
    }
    var startDateString = experience.startDate ? (0, time_1.formatMonthYear)(experience.startDate) : '';
    var endDateString = experience.endDate ? (0, time_1.formatMonthYear)(experience.endDate) : 'Now';
    var dates;
    if (startDateString && endDateString) {
        dates = "(".concat(startDateString, " - ").concat(endDateString, ")");
    }
    else if (endDateString) {
        dates = "(".concat(endDateString, ")");
    }
    else {
        dates = '';
    }
    return "".concat(companyName && "".concat(companyName, " ")).concat(dates);
}
exports.renderExperience = renderExperience;
function renderExperienceGo30(experience) {
    if (!experience)
        return '';
    var companyName = (0, get_1.default)(experience, 'company.name', 'Unknown company');
    if (!experience.startDate && !experience.endDate) {
        if (companyName) {
            return companyName;
        }
        return '';
    }
    return "".concat(companyName && "".concat(companyName, " "));
}
exports.renderExperienceGo30 = renderExperienceGo30;
function renderSegment(staticDataNames, segment) {
    var suffix = segment.loading ? '' : "(".concat(segment.eplCount, ")");
    if (segment.comment) {
        return "".concat(segment.comment, " ").concat(suffix);
    }
    if (!staticDataNames)
        return null;
    if (segment.countries && segment.countries.length) {
        var countryNames = segment.countries.map(function (country) { return country.name; }).join(', ');
        return "".concat(countryNames, " ").concat(suffix);
    }
    if (segment.expertFocusRegionId) {
        var regionName = staticDataNames.expertFocusRegions[segment.expertFocusRegionId];
        return "".concat(regionName, " ").concat(suffix);
    }
    return "Unnamed segment ".concat(suffix);
}
exports.renderSegment = renderSegment;
function renderMoney(staticDataNames, currencyId, amount) {
    var formatted = currency_formatter_1.default.format(amount, {
        code: staticDataNames.currencies[currencyId],
        locale: 'de-DE',
    });
    return "".concat(formatted);
}
exports.renderMoney = renderMoney;
function renderExpertRate(staticDataNames, epl) {
    var pricing = epl.pricingId ? staticDataNames.pricings[epl.pricingId] : '';
    if (epl.credits) {
        return "".concat(epl.credits, " credit(s) ").concat(pricing);
    }
    if (epl.fee) {
        var rate = renderMoney(staticDataNames, epl.feeCurrencyId, epl.fee);
        return "".concat(rate, " ").concat(pricing);
    }
    return '';
}
exports.renderExpertRate = renderExpertRate;
var helpers = {
    atheneumOffice: renderAtheneumOffice,
    country: renderCountry,
    segment: renderSegment,
    money: renderMoney,
    rate: renderExpertRate,
};
exports.default = helpers;
